import { render } from "./orariPrenotazioneModal.vue?vue&type=template&id=3cab48c4&scoped=true&ts=true"
import script from "./orariPrenotazioneModal.vue?vue&type=script&lang=ts"
export * from "./orariPrenotazioneModal.vue?vue&type=script&lang=ts"

import "./orariPrenotazioneModal.vue?vue&type=style&index=0&id=3cab48c4&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cab48c4"]])

export default __exports__